:host {
  @apply w-full relative;
}

.input-select-secondary {
  @apply inline-flex md:flex-col w-full relative;
}

.input-select-secondary__select {
  @apply appearance-none;
  @apply font-open-sans font-normal text-base tracking-normal;
  @apply leading-snug outline-none resize-none;
  @apply pt-4 pb-2 pl-4 pr-3 w-full max-w-full;
  @apply border-solid border;
  @apply transition-colors duration-200;

  background-position: top 50% right 12px;
  background-size: 15px;
  border-radius: var(--border-radius-dropdown);
  border-color: var(--clrs-border-dropdown-default);
  background-color: var(--clrs-bg-dropdown-default);
  color: var(--clrs-text-dropdown-default);
}

.input-select-secondary__select:hover {
  border-color: var(--clrs-border-dropdown-hover);
}

.input-select-secondary__select--error {
  border-color: var(--clrs-border-dropdown-error);
}

.input-select-secondary__select:focus ~ .input-select__label {
  color: var(--clrs-text-dropdown-label-active);
}

.input-select-secondary__select:focus {
  border-color: var(--clrs-border-dropdown-active);
  background-color: var(--clrs-bg-dropdown-active);
  color: var(--clrs-text-dropdown-active);
  box-shadow: var(--box-shadow-dropdown-active);
}

.input-select-secondary__select--disabled {
  border-color: var(--clrs-border-dropdown-disabled);
  background-color: var(--clrs-bg-dropdown-disabled);
  color: var(--clrs-text-dropdown-disabled);
}

.input-select-secondary__label {
  @apply absolute inset-4 origin-top-left transition-all;
  @apply font-open-sans font-normal pointer-events-none cursor-text;
  @apply text-sm leading-4;
  color: var(--clrs-text-label-default);
}

.input-select-secondary__label--error {
  color: var(--clrs-text-dropdown-label-error);
}

.input-select-secondary__label--disabled {
  color: var(--clrs-text-dropdown-disabled);
}

.input-select-secondary__label--has-value {
  @apply top-[5px] text-xxs;
}

.input-select__icon-container {
  @apply absolute right-4 h-full flex items-center pointer-events-none;
  width: 16px;
  color: var(--clrs-icon-dropdown-default);
}

.input-select__icon-container--disabled {
  color: var(--clrs-icon-dropdown-disabled);
}
